import AppBar from "@material-ui/core/AppBar";
import Tab from "@material-ui/core/Tab";
import Tabs from "@material-ui/core/Tabs";
import React, { ChangeEvent, FC, useEffect, useState } from "react";
import { FormControl, InputLabel, MenuItem, Select } from "@material-ui/core";
import { useDispatch, useSelector } from "react-redux";

import CampaignCreationSlideContainer from "../../../components/CampaignCreation/CampaignCreationSlideContainer";
import CreateNewAdGroupTab from "./tabs/CreateNewAdGroupTab";
import MediaTypeSelector from "./components/MediaTypeSelector";
import NoAdGroupsFound from "./components/NoAdgroupsFound";
import SelectSavedAdGroupTab from "./tabs/SelectSavedAdGroupTab";
import classes from "./AdGroupSelectionSlide.module.scss";
import { MediaType } from "./components/MediaTypeSelector/types";
import { PageStepComponentProps } from "../../../components/modules/BaseStepper/BaseStepper";
import { ReduxApplicationState } from "../../../types/ReduxTypes/ReduxApplicationState";
import { a11yProps } from "../../../utils/a11yProps";
import {
  setAdGroupTemplate,
  setCampaignBasicDetails,
  setCampaignToCreateSelectedAdvertiser,
} from "../../../redux/reducers/campaignToCreate";

const AdGroupSelectionSlide: FC<PageStepComponentProps> = ({
  isAttemptingToGoNext,
  setIsAttemptingToGoNext,
  handleNext,
}) => {
  const campaignToCreate = useSelector((state: ReduxApplicationState) => state.campaignToCreate);
  const { basicDetails } = campaignToCreate!;

  const [adGroupSelectionTab, setAdGroupSelectionTab] = useState<0 | 1>(0);
  const [mediaType, setMediaType] = useState<MediaType>(basicDetails.isVideoCampaign ? "video" : "display");
  const [selectedAdvertiserId, setSelectedAdvertiserId] = useState("");

  const advertisers = useSelector((state: ReduxApplicationState) => state.agency.advertisers);

  const dispatch = useDispatch();

  useEffect(() => {
    if (setIsAttemptingToGoNext) return;

    const selectedAdvertiser = advertisers.find(
      (advertiser) => advertiser.brandgenAdvertiserId === selectedAdvertiserId,
    );

    if (selectedAdvertiser) dispatch(setCampaignToCreateSelectedAdvertiser(selectedAdvertiser));
  }, [advertisers, dispatch, mediaType, selectedAdvertiserId, setIsAttemptingToGoNext]);

  const handleTabChangeChange = (_: ChangeEvent<{}>, newTabValue: 0 | 1) => {
    setAdGroupSelectionTab(newTabValue);
    dispatch(setAdGroupTemplate(newTabValue === 0));
  };

  const handleMediaTypeChange = (selectedMediaType: MediaType) => {
    setMediaType(selectedMediaType);
    dispatch(setCampaignBasicDetails({ ...basicDetails, isVideoCampaign: selectedMediaType === "video" }));
  };

  const mainContent = () => (
    <>
      <AppBar position="static" className={classes.tabs}>
        <Tabs value={adGroupSelectionTab} onChange={handleTabChangeChange} aria-label="AdGroup Selection Tabs">
          <Tab label="Select From Saved AdGroups" {...a11yProps(0)} />
          <Tab label="Create New AdGroup" {...a11yProps(1)} />
        </Tabs>
      </AppBar>

      <CreateNewAdGroupTab
        isAttemptingToGoNext={isAttemptingToGoNext}
        setIsAttemptingToGoNext={setIsAttemptingToGoNext}
        handleNext={handleNext}
        selectedTabPanelValue={adGroupSelectionTab}
      />

      <SelectSavedAdGroupTab
        isAttemptingToGoNext={isAttemptingToGoNext}
        setIsAttemptingToGoNext={setIsAttemptingToGoNext}
        handleNext={handleNext}
        selectedTabPanelValue={adGroupSelectionTab}
        showCheckbox={!!handleNext}
      />
    </>
  );

  return (
    <div
      style={{
        padding: !setIsAttemptingToGoNext ? "4rem" : 0,
      }}
    >
      {!setIsAttemptingToGoNext && (
        <div
          style={{
            margin: "3rem 0",
            width: "50rem",
            display: "flex",
            gap: 50,
          }}
        >
          <FormControl fullWidth>
            <InputLabel id="demo-simple-select-label">Select Advertiser</InputLabel>
            <Select
              labelId="demo-simple-select-label"
              id="demo-simple-select"
              value={selectedAdvertiserId}
              label="Advertiser"
              onChange={(e) => {
                setSelectedAdvertiserId(e.target.value as string);
              }}
            >
              {advertisers.map((advertiser) => {
                return (
                  <MenuItem key={advertiser.brandgenAdvertiserId} value={advertiser.brandgenAdvertiserId}>
                    {advertiser.name}
                  </MenuItem>
                );
              })}
            </Select>
          </FormControl>
          <MediaTypeSelector mediaType={mediaType} onChange={handleMediaTypeChange} />
        </div>
      )}

      {setIsAttemptingToGoNext ? (
        <CampaignCreationSlideContainer heading="Adgroup">{mainContent()}</CampaignCreationSlideContainer>
      ) : selectedAdvertiserId ? (
        mainContent()
      ) : (
        <NoAdGroupsFound />
      )}
    </div>
  );
};

export default AdGroupSelectionSlide;
